import { Component, OnInit, OnDestroy } from '@angular/core';
import { MaService } from '../../services/ma.service';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';
import {
  map,
  tap,
  distinctUntilChanged,
  filter,
  takeUntil,
} from 'rxjs/operators';

const UUID_PATTERN = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
@Component({
  selector: 'ma-flow-check',
  templateUrl: './flow-check.component.html',
  styleUrls: ['./flow-check.component.scss'],
})
export class FlowCheckComponent implements OnInit, OnDestroy {
  constructor(private maService: MaService) {}

  isLoading$ = new BehaviorSubject<boolean>(false);
  flowIdInput$ = new BehaviorSubject<string>('');
  flowId$ = this.flowIdInput$.pipe(
    map((flowId) => flowId.trim()),
    map((flowId) => (UUID_PATTERN.test(flowId) ? flowId : null)),
    distinctUntilChanged(),
  );

  canCheck$ = combineLatest([this.flowId$, this.isLoading$]).pipe(
    map(([flowId, isLoading]) => !isLoading && !!flowId),
  );

  public checkResult = null;
  private readonly destroy$: Subject<void> = new Subject<void>();

  ngOnInit() {
    // automatically trigger checkflow if there is an valid UUID
    this.flowId$
      .pipe(
        takeUntil(this.destroy$),
        filter((flowId) => !!flowId),
        tap(() => this.checkFlow()),
      )
      .subscribe();
  }

  checkFlow() {
    if (this.isLoading$.value) {
      return;
    }
    this.isLoading$.next(true);
    this.checkResult = null;
    this.maService.checkActivity(this.flowIdInput$.value).subscribe(
      (result) => {
        this.isLoading$.next(false);
        this.checkResult = result;
      },
      (_error) => {
        this.isLoading$.next(false);
      },
    );
  }

  updateFlowId(flowId) {
    this.checkResult = false;
    this.flowIdInput$.next(flowId);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }
}
